<template>
  <v-card class="app-card" text>
    <v-card-text>
      <gg-btn color="green" tile dark @click="launch_cpanel(hostingid)">Launch cPanel</gg-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { launch_cpanel } from '@/helpers/helpers'

export default {
  name: 'HostingCpanelLaunch',
  props: {
    hostingid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    launch_cpanel,
  }
}
</script>
